export const FLOW_DESIGER_PALETTE_SELECT_TAB =
  'FLOW_DESIGER_PALETTE_SELECT_TAB';
/**
 * @param PaletteTab tabId
 */
export const selectPaletteTab = tabId => ({
  type: FLOW_DESIGER_PALETTE_SELECT_TAB,
  payload: { tabId },
});

export const FLOW_DESIGER_PALETTE_SCROLL_TO_STEP =
  'FLOW_DESIGER_PALETTE_SCROLL_TO_STEP';

/**
 * @param string stepId
 */
export const scrollToPaletteStep = stepId => ({
  type: FLOW_DESIGER_PALETTE_SCROLL_TO_STEP,
  payload: { stepId },
});
